import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { GetAllGGNotificationLot, GGNotificationLotDelete, resetLotCreationStatus } from "./slice"
import { GGNotificationLotDTO } from "./dataservice/dto"
import { TrashIcon } from "../../../../ui/icons/trash"
import Button from "../../../../ui/molecules/button"
import { Alert } from "../../../../ui/organisms/alert"
import { PopupForm } from "../../../../ui/organisms/popupForm"
import { CoCPopup } from "./popup"

export function GlobalGapCoCList() {
    const dispatch = useAppDispatch()
    const ggnotificationCoCState = useAppSelector(state => state.ggNotificationCoC)
    const [showAddPopup, setShowAddPopup] = useState<boolean>(false)
    const [showAlert, setShowAlert] = useState<boolean>(false)
    const [lotToDelete, setLotToDelete] = useState<GGNotificationLotDTO | null>(null)

    useEffect(() => {
        if(ggnotificationCoCState.tabIdToUpdate)
            dispatch(GetAllGGNotificationLot({
                itemsPerPage: 0,
                page: 0,
                ggNotificationCOCTabId: ggnotificationCoCState.tabIdToUpdate
            }))
    }, [ggnotificationCoCState.tabIdToUpdate])

    useEffect(() => {
        if (ggnotificationCoCState.lotCreationStatus === 'successfully') {
            dispatch(resetLotCreationStatus())
            dispatch(GetAllGGNotificationLot({
                itemsPerPage: 0,
                page: 0,
                ggNotificationCOCTabId: ggnotificationCoCState.tabIdToUpdate
            }))
        }
    }, [ggnotificationCoCState.lotCreationStatus])

    return (
        <div>
            <div style={{ padding: '24px' }}>
                <table id="users-table" className="w-[100%]">
                    <thead className="h-[52px] uppercase">
                        <tr>
                            <th style={{ borderTopLeftRadius: '8px' }}></th>
                            <th className="width-[130px]">Sito (Indirizzo)</th>
                            <th className="width-[130px]">Prodotti</th>
                            <th className="width-[100px]">Quantativi totali previsti per la commercializzazione</th>
                            <th className="width-[130px]">Periodo di manipolazione</th>
                            <th className="width-[20%]">Etichettatura</th>
                            <th className="width-[130px]">Paese di Destinazione</th>
                            <th style={{ borderTopRightRadius: '8px', width: '40px' }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            ggnotificationCoCState.getAllLotResponse?.data.map((m, index) =>
                                <tr
                                    key={index}
                                    style={{
                                        color: '#4D797F',
                                        background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                    }}
                                >
                                    <td></td>
                                    <td>{m.address}</td>
                                    <td>{m.products}</td>
                                    <td>{m.totalQuantity}</td>
                                    <td>{m.manipulationPeriod}</td>
                                    <td>{m.labelling ? 'Sì' : 'No'}</td>
                                    <td>{m.destinationCountry}</td>
                                    <td>
                                        <button onClick={() => {
                                            setLotToDelete(m)
                                            setShowAlert(true)
                                        }}>
                                            <TrashIcon color="red" size={20} />
                                        </button>
                                    </td>
                                </tr>
                            )}
                    </tbody>
                </table>

                <div className="mt-5" style={{ display: 'flex', justifyContent: 'flex-end', gap: '24px' }}>
                    <Button
                        variant="outline"
                        color="dimgrey"
                        size="md"
                        iconPosition="off"
                        label="Aggiungi"
                        onClick={() => setShowAddPopup(true)}
                    />
                </div>
            </div>
            {
                (showAlert && lotToDelete) && (
                    <Alert title="Conferma operazione" close={() => setShowAlert(false)}>
                        <div style={{ display: "flex", flexDirection: 'column', justifyContent: 'center' }}>
                            <div className="pb-3">
                                <div>
                                    Sei sicuro di voler eliminare il seguente sito?
                                </div>
                                <div className="mt-3 font-bold">
                                    {`${lotToDelete.address} - ${lotToDelete.products}`}
                                </div>
                            </div>
                            <div className="mt-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Button
                                    variant="outline"
                                    color="dimgrey"
                                    iconPosition="off"
                                    label="Annulla"
                                    size="md"
                                    onClick={() => setShowAlert(false)}
                                />
                                <div className="pl-8">
                                    <Button
                                        variant="solid"
                                        color="orange"
                                        iconPosition="off"
                                        label="Elimina"
                                        size="md"
                                        onClick={() => {
                                            dispatch(GGNotificationLotDelete(lotToDelete.id!))
                                            setShowAlert(false)
                                        }}
                                    />
                                </div>
                            </div>

                        </div>
                    </Alert>
                )
            }
            {
                showAddPopup &&
                <PopupForm title={`Aggiungi sito`} headerGreen close={() => setShowAddPopup(false)}>
                    <CoCPopup close={() => setShowAddPopup(false)}></CoCPopup>
                </PopupForm>
            }
        </div>
    )
}